export const ErrorCode = {
  EXPIRED_ACCESS_TOKEN: 'not_authenticated',
};

export const ErrorDetails = {
  EXCEED_HR_BPM:
    'Some waveform indexes exceeds valid HR range, waveform indexes',
};
